var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1029,
    height: 1338,
    viewBox: "0 0 1029 1338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_34_3476)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 771.5,
    cy: 566.5,
    r: 277.5,
    fill: "#D622DA",
    fillOpacity: 0.59
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_34_3476",
    x: 0,
    y: -205,
    width: 1543,
    height: 1543,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 247,
    result: "effect1_foregroundBlur_34_3476"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBg);
export default __webpack_public_path__ + "static/media/faceBg.794e6d9858922533d70074d33abf681f.svg";
export { ForwardRef as ReactComponent };